/**
 * Rounds a number to two significant digits with a minimum of two decimal places.
 * @function roundToTwoSignificantDigitsWithMinDecimals
 * @param {number} num - The number to round.
 * @returns {number} The rounded number with at least two decimal places.
 */
export const roundToTwoSignificantDigitsWithMinDecimals = (
  num: number,
): number => {
  const numStr = num.toString();
  // Remove leading zeros and extract the significant part
  const leadingZeros = numStr.match(/^0+\.?0*/)?.[0] || '';
  const significantPart = numStr.replace(leadingZeros, '').substring(0, 2);
  const minDecimals = 2;

  // Calculate the necessary number of decimal places
  let roundingDecimals =
    num < 1
      ? leadingZeros.length - 2 + significantPart.length
      : significantPart.length - 1;

  // Ensure at least 2 decimal places
  roundingDecimals = Math.max(minDecimals, roundingDecimals);

  // Return the rounded number with the calculated decimal places
  return parseFloat(num.toFixed(roundingDecimals));
};
